export const coerceValue = (value: unknown): string | number | boolean | null => {
  if (value === undefined || value === null) return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') return null;
    const num = Number(trimmed);
    return isFinite(num) ? num : trimmed;
  }
  // object, array, symbol, function, bigint — none are valid for financial cell data
  return null;
};
